import { useRef } from 'react';
import { useGetNotificationPreferencesQuery } from './api';
import {
  type RealtimeNotificationPayload,
  shouldShowBrowserPopup,
  showBrowserNotification,
} from './browserNotifications';
import { useRealtime } from './useRealtime';

/**
 * Browser popups for in-app notifications.
 *
 * The notification centre remains the source of truth; these are an optional, intrusive
 * channel gated on `webPush` in preferences and the browser permission prompt.
 */
export function useBrowserNotifications(enabled: boolean): void {
  const { data: prefsData } = useGetNotificationPreferencesQuery(undefined, { skip: !enabled });
  const prefsRef = useRef(prefsData?.data);
  prefsRef.current = prefsData?.data;

  useRealtime(enabled, {
    onNotificationCreated: (payload) => {
      const typed = payload as RealtimeNotificationPayload;
      if (!shouldShowBrowserPopup(typed, prefsRef.current)) return;
      showBrowserNotification({
        title: typed.title,
        body: typed.body,
        tag: typed.id,
        url: typed.redirectUrl,
      });
    },
  });
}
